import { Operations } from '@/app/graphql/payment/sdk.payment';

export function useFilterOperations() {
  const getOperations = (operation: Operations | null) => {
    if (!operation) return [];

    const o24Operations = [
      Operations.Rko_2IndividualCardOwn,
      Operations.Rko_2IndividualCardForeign,
      Operations.Rko_2BusinessCardForeign,
    ];
    const card2rkoOperations = [Operations.BusinessCard_2RkoOwn, Operations.BusinessCard_2RkoForeign];

    if (o24Operations.includes(operation)) return o24Operations;

    if (card2rkoOperations.includes(operation)) return card2rkoOperations;

    return [operation];
  };

  return {
    getOperations,
  };
}
